export default __webpack_public_path__ + "static/media/OKR_Baseline.b25f4b6b.png";